import { Check, X } from 'lucide-react'
import { evaluatePassword } from '../lib/passwordPolicy'
import { cn } from '@/lib/utils'

export function PasswordRequirements({ password }: { password: string }) {
  const rules = evaluatePassword(password)
  return (
    <ul className="flex flex-col gap-1 text-xs">
      {rules.map((rule) => (
        <li
          key={rule.id}
          className={cn(
            'flex items-center gap-1.5',
            rule.valid ? 'text-success' : 'text-muted-foreground',
          )}
        >
          {rule.valid ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />}
          {rule.label}
        </li>
      ))}
    </ul>
  )
}
